import { Component, OnInit } from '@angular/core';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { ApiService } from '../../../core/services/api.service';
import { LoaderService } from '../../../core/services/loading.service';
import { HigTealiumNgxService } from 'hig-tealium-ngx';

@Component({
    selector: 'app-sold-proposals',
    templateUrl: './sold-proposals.component.html',
    styleUrls: ['./sold-proposals.component.scss'],
    standalone: false
})
export class SoldProposalsComponent implements OnInit {
    soldProposalsData: Object;
    showCancelConfirmation: boolean = false;

    soldProposalsHeader: ColDef[] = [
        {
            headerName: 'EFFECTIVE DATE',
            field: 'effctvDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            // cellClass: ['custom-cell-margin'],
            flex: 1,
            valueFormatter: (params) => {
                const epoch = (params.value);
                if (params.value) {
                    const [year, month, day] = params.value.split('-');
                    const formattedDate = `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
                    return formattedDate;
                } else {
                    return null;
                }
            }
        },
        {
            headerName: 'EXPIRATION DATE',
            field: 'exprtnDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1,
            valueFormatter: (params) => {
                const epoch = (params.value);
                if (params.value) {
                    const [year, month, day] = params.value.split('-');
                    const formattedDate = `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
                    return formattedDate;
                } else {
                    return null;
                }
            }
        },
        {
            headerName: 'DOCUMENT TYPE',
            field: 'docType',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'REV.#',
            field: 'intrntRvsnNmbr',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'REVISION DATE',
            field: 'intrntRvsnDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1,
            valueFormatter: (params) => {
                const isoString = params.value;
                if (isoString) {
                    const date = new Date(isoString);
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const day = date.getDate().toString().padStart(2, '0');
                    const year = date.getFullYear();
                    let hours = date.getHours();
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    const ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    const formattedHours = hours.toString().padStart(2, '0');
                    const formattedDate = `${month}/${day}/${year} ${formattedHours}:${minutes} ${ampm}`;
                    return formattedDate;
                } else {
                    return null;
                }
            }
        },
        {
            headerName: '',
            field: 'icon',
            sortable: false,
            cellClass: 'text-right',
            flex: 1,
            suppressMovable: true,
            resizable: false,
            cellRenderer: (params: any) => {
                (params.data?.reportRecordActions?.[0]?.PDF)
                return `<span class="pdf-icon  " style="cursor:pointer;" title="Download PDF">
                           <i class="fa fa-file-pdf-o icon"
      style="font-size:22px;color:red"
      data-action="pdf"
      aria-label="pdf"></i>
                        </span>`;
            },
            onCellClicked: (params: any) => {

                this.onPdfCellClicked(params)
            }
        }
    ];
    public defaultColDef: ColDef = {
        resizable: false,
        autoHeight: true,
        wrapText: true,
        wrapHeaderText: true
    };
    soldList: any[] = [];
    public JSON = JSON;
    constructor(
        public apiService: ApiService, public loaderService: LoaderService, public ngxTealiumService: HigTealiumNgxService
                    ) {
                        let udo = {
                            site_name: 'TREORiskManagement',
                            page_name: 'Sold Proposals',
                            component_name: 'Program Tab',
                            rmis_email: this.loaderService.getItem('emailID'),
                            rmis_user_id: this.loaderService.getItem('userId')
                        };
                        ngxTealiumService.updateUDOObject(udo); 
    }
    onClickHandler(...event) {
    }
    ngOnInit() {
        this.fetchExistingAlert();
    }
    onGridReadyAddendaDocuments(params: GridReadyEvent) {
    }

    // below is new code.

    onPdfCellClicked(event: any): void {
        console.log("event", event.data);
        const rowData = event.data;

        // Determine suffix based on docTypePrmtr
        let suffix = '';
        switch (rowData.docTypePrmtr) {
            case 'PGM_SPA_ADM':
                suffix = 'cpm';
                break;
            case 'PGM_SPA_CPY':
                suffix = 'cph';
                break;
            case 'PGM_SPA_PRL':
                suffix = 'proposal'; //change the name to actual suffix of the downloaded file from legacy
                break;
            case 'PGM_SPA_COM':
                suffix = 'commission'; //change the name to actual suffix of the downloaded file from legacy
                break;
            default:
                suffix = 'draft'; //doesn't match known types
        }

        // Create dynamic variable name with .pdf suffix
        const dynamicVarName = `_${rowData.cnsmrRqstId}${suffix}.pdf`;

        let payload = {};

        if (rowData.docTypePrmtr === 'PGM_SPA_ADM' || rowData.docTypePrmtr === 'PGM_SPA_CPY') {
            payload = {
                reportFormat: 'PDF',
                reportType: 'SOLD_PROGRAM_ADDENDUM',
                orgnztnId: this.loaderService.getItem('orgId'),
                billingSearchResult: {
                    documentPolicyID: rowData?.cnsmrRqstId || '',
                    documentType: rowData?.docTypePrmtr || ''
                }
            };
        }
        else {
            payload = {
                reportFormat: 'PDF',
                reportType: 'DRAFT_SOLD_LIST',
                orgnztnId: this.loaderService.getItem('orgId'),
                billingSearchResult: {
                    documentControlNumberPDF: rowData?.dcmntCntrlNmbr || ' ',
                    documentPolicyID: rowData?.cnsmrRqstId || '',
                    documentType: rowData?.docTypePrmtr || ''
                }
            };
        }

        const endpoint = 'export';
        this.apiService?.postDataBlob(endpoint, payload,)?.subscribe({
            next: (response: any) => {
                this.loaderService.hideLoader();
                const blob = new Blob([response.body], { type: response.headers.get('content-type') });
                const time = new Date().getTime()
                const fileName = dynamicVarName;
                const file = new File([blob], fileName, { type: response.headers.get('content-type') });
                FileSaver.saveAs(file, `${fileName}`);
            },
            error: (err) => {
                this.loaderService.hideLoader();

                console.error('Export failed:', err);
                this.showCancelConfirmation = true;
            }
        });
    }


    // above is new code.



    fetchExistingAlert() {
        const payload = {
            actionType: "PROGRAM_MANAGE",
            operation: "RETRIEVE_SOLD_PROPOSALS_LIST",
            organizationId: this.loaderService.getItem('orgId')
        }
        this.apiService.postData('programs', payload)?.subscribe({
            next: (resp) => {
                this.loaderService.hideLoader();
                this.soldList = resp.soldProposalList
            },
        })
    }
    onCellClicked(event: any) {

    }

    confirmCancel(confirm: boolean): void {
        this.showCancelConfirmation = false;

    }

}
